import { dataVideoSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoSolid = /*#__PURE__*/createIcon(dataVideoSolid)
export default IconVideoSolid
